import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { DailySessionStorage, featureEnabled } from 'utils';
import { getUnconfiguredUserListings } from 'api/ListingController';
import ShowingSettingsModal, { ListingConfigData } from '.';

const SHOWING_SETTINGS_MODAL_PARAM = 'showShowingSettingsModal';
const storage = new DailySessionStorage(SHOWING_SETTINGS_MODAL_PARAM);

const DailyShowingSettingsModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<ListingConfigData | null>(null);
  const location = useLocation();
  const history = useHistory();

  const isCypress = () => Boolean((window as any).Cypress);

  const isAuthorizedByParams = () => {
    const searchParams = queryString.parse(location.search);
    if (searchParams[SHOWING_SETTINGS_MODAL_PARAM] === 'true') {
      const newSearchParams = { ...searchParams } as Record<string, string>;
      delete newSearchParams[SHOWING_SETTINGS_MODAL_PARAM];

      const path = `${location.pathname}?${new URLSearchParams(
        newSearchParams,
      ).toString()}`;

      history.replace(path);
      return true;
    }
    return false;
  };

  const fetchUnconfiguredListings = async () => {
    if (!featureEnabled('showingSettingsFeature')) return;

    const d = await getUnconfiguredUserListings();
    if (!d.listings.length) return;

    setData(d);
    setOpen(true);
  };

  useEffect(() => {
    if (!isCypress() && storage.authorize()) {
      fetchUnconfiguredListings();
      return;
    }

    if (isAuthorizedByParams()) {
      fetchUnconfiguredListings();
    }
  }, [location]);

  return (
    <ShowingSettingsModal
      open={open}
      setOpen={setOpen}
      data={data}
      setData={setData}
    />
  );
};

export default DailyShowingSettingsModal;
